import { useState } from 'react';
import { Link } from 'react-router-dom';
import { openRandomPlayLink } from '../../../config/playLinks';
import { PRIMARY_NAV_ITEMS, ROUTES } from '../../../router/routes';

export default function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <nav className="sticky top-0 left-0 right-0 z-50">
      {/* Top bar - dark navy */}
      <div className="bg-[#1a1040] border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="flex items-center justify-between h-14 sm:h-16">
            {/* Logo */}
            <Link to={ROUTES.home} className="flex items-center">
              <img src="/koalabet-logo.png" alt="KoalaBet logo" className="h-10 sm:h-12 w-auto" />
            </Link>

            {/* Right side */}
            <div className="hidden lg:flex items-center space-x-6">
              <button
                type="button"
                onClick={openRandomPlayLink}
                className="flex items-center space-x-2 px-4 py-2 bg-orange-500 hover:bg-orange-600 text-white text-sm font-semibold rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-user-line text-base"></i>
                <span>Log in</span>
              </button>
            </div>

            <button
              type="button"
              className="lg:hidden inline-flex items-center justify-center min-h-[44px] min-w-[44px] p-2.5 rounded-md"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Toggle navigation menu"
            >
              <i className="ri-menu-line text-2xl text-white"></i>
            </button>
          </div>
        </div>
      </div>

      {/* Second nav row - purple */}
      <div className="bg-[#5b21b6] border-b border-purple-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="hidden lg:block h-11 overflow-x-auto">
            <div className="flex items-center justify-center h-11 w-max min-w-full gap-6 xl:gap-8 2xl:gap-10">
              {PRIMARY_NAV_ITEMS.map((link) => (
                <div key={`${link.label}-${link.to}`} className="relative">
                  {link.openRandomPartner ? (
                    <button
                      type="button"
                      onClick={() => openRandomPlayLink()}
                      className="flex items-center gap-1.5 xl:gap-2 h-11 text-xs xl:text-sm font-medium text-purple-100 hover:text-white transition-colors whitespace-nowrap cursor-pointer bg-transparent border-0 p-0"
                    >
                      <i className={`${link.icon} text-sm xl:text-base`}></i>
                      <span>{link.label}</span>
                      {link.badge && (
                        <span className="ml-1 px-1.5 py-0.5 bg-orange-500 text-white text-[10px] font-bold rounded">
                          {link.badge}
                        </span>
                      )}
                    </button>
                  ) : (
                    <Link
                      to={link.to}
                      className="flex items-center gap-1.5 xl:gap-2 h-11 text-xs xl:text-sm font-medium text-purple-100 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                    >
                      <i className={`${link.icon} text-sm xl:text-base`}></i>
                      <span>{link.label}</span>
                      {link.badge && (
                        <span className="ml-1 px-1.5 py-0.5 bg-orange-500 text-white text-[10px] font-bold rounded">
                          {link.badge}
                        </span>
                      )}
                    </Link>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-[#1a1040] border-t border-white/10">
          <div className="px-4 sm:px-6 py-4 space-y-2">
            {PRIMARY_NAV_ITEMS.map((link) => (
              <div key={`${link.label}-${link.to}`}>
                {link.openRandomPartner ? (
                  <button
                    type="button"
                    onClick={() => {
                      openRandomPlayLink();
                      setIsMobileMenuOpen(false);
                    }}
                    className="flex items-center space-x-2 min-h-[44px] py-3 text-sm text-gray-300 hover:text-white w-full text-left bg-transparent border-0 px-2 rounded-md"
                  >
                    <i className={`${link.icon} text-base`}></i>
                    <span>{link.label}</span>
                    {link.badge && (
                      <span className="px-1.5 py-0.5 bg-orange-500 text-white text-[10px] font-bold rounded">
                        {link.badge}
                      </span>
                    )}
                  </button>
                ) : (
                  <Link
                    to={link.to}
                    onClick={() => setIsMobileMenuOpen(false)}
                    className="flex items-center space-x-2 min-h-[44px] py-3 px-2 rounded-md text-sm text-gray-300 hover:text-white"
                  >
                    <i className={`${link.icon} text-base`}></i>
                    <span>{link.label}</span>
                    {link.badge && (
                      <span className="px-1.5 py-0.5 bg-orange-500 text-white text-[10px] font-bold rounded">
                        {link.badge}
                      </span>
                    )}
                  </Link>
                )}
              </div>
            ))}
            <div className="pt-3 border-t border-white/10 flex items-center space-x-4">
              <button
                type="button"
                onClick={openRandomPlayLink}
                className="min-h-[44px] px-5 py-2.5 bg-orange-500 text-white text-sm font-semibold rounded-md whitespace-nowrap cursor-pointer"
              >
                Log in
              </button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}